var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ChangeDetectorRef, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { NavigationService } from '../services/navigation/navigation.service';
import { PageNames } from '../shared/page-names.enum';
import { NavigableComponent } from '../model/navigable-component';
import { ProductCarouselComponent } from '../product-carousel/product-carousel.component';
import { TranslateService } from '@ngx-translate/core';
import { CarouselService } from '../services/carousel/carousel.service';
import { AnalyticsService } from '../services/analytics/analytics.service';
import { TvShopStateService } from '../services/state/tv-shop-state.service';
import { NavigableComponentConfigurationHomePage } from '../constants/navigation/homepage.constants';
import { StreamingServicesUtil } from '../utils/streaming-services.util';
import { NavigationUtil } from '../utils/navigation/navigation.util';
import { OmapiIdsUtils } from '../shared/utils/omapi-ids/omapi-ids-utils';
var TvshopComponent = /** @class */ (function (_super) {
    __extends(TvshopComponent, _super);
    function TvshopComponent(navigationService, translateService, changeDetector, carouselService, analyticsService, stateService) {
        var _this = _super.call(this, navigationService) || this;
        _this.navigationService = navigationService;
        _this.translateService = translateService;
        _this.changeDetector = changeDetector;
        _this.carouselService = carouselService;
        _this.analyticsService = analyticsService;
        _this.stateService = stateService;
        _this.pageConfiguration = NavigableComponentConfigurationHomePage;
        _this.productsInCarousel = [];
        _this.tvPackGroupsInCarousel = [];
        _this.streamingBundlesForHeroCarousel = [];
        NavigationUtil.processNavigationPage(_this.pageConfiguration, _this.stateService);
        return _this;
    }
    TvshopComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.stateService.setIsStreamingBundleOrder(false);
        this.navigationService.setCurrentPageComponent(PageNames.HOMEPAGE);
        this.navigationService.state.infiniteScrolling = true;
        this.processPacks();
        this.processStreamingServices();
        this.processPackGroups();
        setTimeout(function () {
            _this.stateService.setLoading(false);
            _this.navigationService.resetNavigation();
        }, 200);
    };
    TvshopComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.navigationService.clearNavigation();
    };
    TvshopComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.registerPageElement(this.homepageElement);
        this.changeDetector.detectChanges();
    };
    TvshopComponent.prototype.processPacks = function () {
        var packs = this.stateService.selectSnapshot(function (state) { return state.tvShopEntertainmentPacks; });
        if (packs.length > 0) {
            this.mainPack = this.carouselService.getMainPack(packs);
            var products = this.carouselService.getProductsInCarousel(packs, this.mainPack);
            this.productsInCarousel = products.sort(function (a, b) { return OmapiIdsUtils.ORDER_PACK.indexOf(a.omapiId) - OmapiIdsUtils.ORDER_PACK.indexOf(b.omapiId); });
            var mainPackArray = [this.mainPack];
            this.analyticsService.onHomePageWithProducts(mainPackArray.concat(this.productsInCarousel).map(function (value) { return value.omapiId; }));
            this.doneLoading = true;
        }
    };
    TvshopComponent.prototype.processStreamingServices = function () {
        var streamingServices = this.stateService.selectSnapshot(function (state) { return state.tvShopStreamingServices; });
        if (streamingServices.length > 0) {
            this.streamingBundlesForHeroCarousel = StreamingServicesUtil.getStreamingBundles(streamingServices);
            this.carouselService.createCarouselImagesForStreamingServices(this.streamingBundlesForHeroCarousel);
        }
    };
    TvshopComponent.prototype.processPackGroups = function () {
        var streamingServices = this.stateService.selectSnapshot(function (state) { return state.tvShopStreamingServices; });
        var groups = this.stateService.selectSnapshot(function (state) { return state.tvShopEntertainmentPackGroups; });
        if (groups.length > 0) {
            this.tvPackGroupsInCarousel = [StreamingServicesUtil.getNetflixStandaloneGroup(groups), StreamingServicesUtil.getStandAloneDisneyPlus(streamingServices)];
            this.carouselService.createCarouselImagesForStreamingServices(this.tvPackGroupsInCarousel);
        }
    };
    return TvshopComponent;
}(NavigableComponent));
export { TvshopComponent };
